import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { DatePicker, Empty } from "antd";
import moment from "moment";
import { Table } from "antd";
import { Excel } from "antd-table-saveas-excel";

const { RangePicker } = DatePicker;

export default function ItemAreaWiseSaleReport() {
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemWiseReport, setItemWiseReport] = useState([]);

  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().endOf("month");
  const formatStart = startOfMonth.format("YYYY-MM-DD");
  const formatEnd = endOfMonth.format("YYYY-MM-DD");

  const [start_date_range, setstart_date_range] = useState(formatStart);
  const [end_date_range, setend_date_range] = useState(formatEnd);
  const [isEmpty, setIsEmpty] = useState(false);

  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);

  const getReportData = async (url, setData, setHeader) => {
    setLoading(true);
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/${url}/B2C`,
      {
        start_date: start_date_range,
        end_date: end_date_range,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      if (data.finalData.length) {
        setData(data.finalData);
        const singleData = data.distinctAreaData;

        const makeHeader = [
          {
            title: "Item",
            dataIndex: "item",
            key: "item",
            width: 200,
            fixed: "left",
          },
        ];

        for (let key of singleData) {
          if (key !== null) {
            makeHeader.push({
              title: key,
              children: [
                {
                  title: "kg",
                  dataIndex: `${key} Kg`,
                  width: 100,
                },
                {
                  title: "QTY",
                  dataIndex: `${key} Qty`,
                  width: 100,
                },
              ],
            });
          }
        }
        setIsEmpty(false);
        setHeader(makeHeader);
      } else {
        setIsEmpty(true);
        setData([]);
        setHeader([]);
      }
    } else {
      swal({
        title: "Something went wrong",
        icon: "error",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getReportData("itemAreaWiseSalesReport", setItemWiseReport, setHeaders);
  }, [start_date_range, end_date_range]);

  const handleDateRange = (dateArr, date) => {
    const dates = [...dateArr];
    setstart_date_range(dates[0]);
    setend_date_range(dates[1]);
  };
  return (
    <div>
      <div className="card p-5 mb-5">
        <div className="row justify-content-between align-items-end">
          <div className="col-md-12">
            <h2 className="mb-5">Item wise Sales Report</h2>
          </div>
          <div className="col-md-4">
            <div>
              <label htmlFor="">Select Date</label>
            </div>
            <RangePicker
              defaultValue={[startOfMonth, endOfMonth]}
              format={"YYYY-MM-DD"}
              onChange={(date, dateString) => handleDateRange(dateString, date)}
            />
          </div>
          {itemWiseReport.length > 0 && (
            <div className="col-md-2">
              <button
                className="btn btn-primary w-100"
                onClick={() => {
                  const excel = new Excel();
                  excel
                    .addSheet("test")
                    .addColumns(headers)
                    .addDataSource(itemWiseReport)
                    .saveAs("Item Areawise Sales Report.xlsx");
                }}
              >
                Download
              </button>
            </div>
          )}
        </div>
      </div>
      {isEmpty ? (
        <Empty />
      ) : (
        <Table
          loading={loading}
          columns={headers}
          dataSource={itemWiseReport}
          scroll={{ x: 1300 }}
          bordered={false}
          className="table  table-head-bg table-borderless table-vertical-center rounded"
        />
      )}
    </div>
  );
}
